<template>
  <el-container v-title data-title="食堂用户账户" style="min-height:98vh">
    <el-header style="text-align: right; font-size: 12px; height: 105px; background-image: linear-gradient(to right, white , green);">
      <Top/>
    </el-header>
    <el-container>
      <el-aside width="200px" style="background-color: rgb(238, 241, 246)">
        <Menu @GoTo='goto'></Menu>
      </el-aside>
      <el-main style="width: 1px">
        <el-header style="height: auto; padding: 0; background-color: #FFF">
          <el-container>
            <el-header height="20px" style="padding: 0; background-color: #FFF">
              <el-breadcrumb separator="/">
                <el-breadcrumb-item>食堂管理</el-breadcrumb-item>
                <el-breadcrumb-item>食堂用户账户</el-breadcrumb-item>
              </el-breadcrumb>
            </el-header>
            <el-main>
              <el-form :inline="true" :model="searchForm" class="demo-form-inline" >
                <el-form-item label="学校">
                  <el-select v-model="searchForm.schoolId" filterable>
                    <el-option v-for="(item, index) in schoolList" :key="index" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="姓名">
                  <el-input v-model="searchForm.realName" placeholder="姓名"></el-input>
                </el-form-item>
                <el-form-item label="每页条数">
                  <el-select v-model="pageSize" @change="handleSizeChange" style="width:80px">
                    <el-option v-for="(item, index) in pageSizes" :key="index" :label="item" :value="item"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="getCanteenAccountlList">查询</el-button>
                  <el-button type="success" @click="openCanteenUserAccountBatchRechargeDialog">批量充值</el-button>
                </el-form-item>
              </el-form>
            </el-main>
          </el-container>
        </el-header>
        <el-table v-loading="loading" :data="tableData" border stripe>
          <el-table-column prop="realName" label="姓名" width="100"></el-table-column>
          <el-table-column prop="schoolName" label="学校" width="100"></el-table-column>
          <el-table-column prop="classNames" label="班级" width="100"></el-table-column>
          <el-table-column prop="userNo" label="工号" width="100"></el-table-column>
          <el-table-column prop="id" label="账户编号" width="300"></el-table-column>
          <el-table-column prop="statusName" label="账户状态" width="100"></el-table-column>
          <el-table-column prop="insertTime" label="启用时间" width="170"></el-table-column>
          <el-table-column prop="balance" :formatter="yuanOfBalanceFormatter" label="可用额" width="100"></el-table-column>
          <el-table-column prop="lockedBalanceShopping" :formatter="yuanOfLockedBalanceShoppingFormatter" label="订餐时锁定额" width="105"></el-table-column>
          <el-table-column prop="lockedBalanceOrder" :formatter="yuanOfLockedBalanceOrderFormatter" label="订餐结束锁定额" width="119"></el-table-column>
          <el-table-column label="操作" width="141">
            <template slot-scope="scope">
              <el-button type="text" @click="openCanteenUserAccountRechargeDialog(scope.row)">充值</el-button>
              <el-button type="text" @click="openCanteenUserAccountDrawDialog(scope.row)" v-if="scope.row.id != null && scope.row.status == '1'">取值</el-button>
              <el-button type="text" @click="canteenUserAccountCancel(scope.row)" v-if="scope.row.id != null && scope.row.status == '1' && scope.row.balance >= 0 && scope.row.lockedBalanceShopping == 0 && scope.row.lockedBalanceOrder == 0">撤销</el-button>
              <el-button type="text" @click="openCanteenUserUnplannedOrderDialog(scope.row)" v-if="scope.row.id != null && scope.row.status == '1'">加餐</el-button>
              <el-button type="text" @click="openCanteenUserUnplannedRefundDialog(scope.row)" v-if="scope.row.id != null && scope.row.status == '1'">退款</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div>
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="getCanteenAccountlList"
            :current-page.sync="currentPage"
            :page-sizes="pageSizes"
            :page-size="pageSize"
            :total="total"
            layout="total,sizes,prev,pager,next" >
          </el-pagination>
        </div>
      </el-main>
      <!-- 弹窗页（充值） -->
      <el-dialog
        title="充值"
        :visible.sync="canteenUserAccountRechargeDialogVisible"
        width="320px"
        :before-close="handleClose">
        <el-form ref="canteenUserAccountRechargeForm" :model="canteenUserAccountRechargeData" :rules="rules" label-width="100px">
          <el-form-item label="充值金额" :required="true" prop="canteenUserAccountRechargeAmount">
            <el-input-number :min="0" :max="100000" :precision="2" v-model="canteenUserAccountRechargeData.canteenUserAccountRechargeAmount" style="width: 160px"></el-input-number> 元
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="canteenUserAccountRecharge">充值</el-button>
            <el-button @click="canteenUserAccountRechargeDialogVisible = false">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
      <!-- 弹窗页（取值） -->
      <el-dialog
        title="取值"
        :visible.sync="canteenUserAccountDrawDialogVisible"
        width="320px"
        :before-close="handleClose">
        <el-form ref="canteenUserAccountDrawForm" :model="canteenUserAccountDrawData" :rules="rules" label-width="100px">
          <el-form-item label="取值金额" :required="true" prop="canteenUserAccountDrawAmount">
            <el-input-number :min="0" :max="100000" :precision="2" v-model="canteenUserAccountDrawData.canteenUserAccountDrawAmount" style="width: 160px"></el-input-number> 元
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="canteenUserAccountDraw">取值</el-button>
            <el-button @click="canteenUserAccountDrawDialogVisible = false">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
      <!-- 弹窗页（批量充值） -->
      <el-dialog
        title="批量充值"
        :visible.sync="canteenUserAccountBatchRechargeDialogVisible"
        width="720px"
        :before-close="handleClose">
        <el-form ref="canteenUserAccountBatchRechargeForm" :model="canteenUserAccountBatchRechargeData" :rules="rules" label-width="110px">
          <el-form-item>
            <el-checkbox-button v-model="toggleSelectValue" v-show="allAvailableCanteenAccountlList && allAvailableCanteenAccountlList.length > 0" @change="toggleSelect(1)">全选</el-checkbox-button>
            <br>
            <el-checkbox-group v-model="canteenUserAccountBatchRechargeData.availableCanteenAccountList">
              <el-checkbox-button v-for="canteenAccount in allAvailableCanteenAccountlList" :label="canteenAccount.userId" :key="canteenAccount.userId">{{canteenAccount.realName}}</el-checkbox-button>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="每个用户充值" :required="true" prop="canteenUserAccountBatchRechargeAmount">
            <el-input-number :min="0" :max="1000000" :precision="2" v-model="canteenUserAccountBatchRechargeData.canteenUserAccountBatchRechargeAmount" style="width: 160px"></el-input-number> 元
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="canteenUserAccountBatchRecharge">充值</el-button>
            <el-button @click="canteenUserAccountBatchRechargeDialogVisible = false">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
      <!-- 弹窗页（加餐） -->
      <el-dialog
        title="加餐"
        :visible.sync="canteenUserUnplannedOrderDialogVisible"
        width="320px"
        :before-close="handleClose">
        <el-form ref="canteenUserUnplannedOrderForm" :model="canteenUserUnplannedOrderData" :rules="rules" label-width="100px">
          <el-form-item label="加餐金额" :required="true" prop="canteenUserUnplannedOrderAmount">
            <el-input-number :min="0" :max="100000" :precision="2" v-model="canteenUserUnplannedOrderData.canteenUserUnplannedOrderAmount" style="width: 160px"></el-input-number> 元
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="canteenUserUnplannedOrder">加餐</el-button>
            <el-button @click="canteenUserUnplannedOrderDialogVisible = false">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
      <!-- 弹窗页（退款） -->
      <el-dialog
        title="退款"
        :visible.sync="canteenUserUnplannedRefundDialogVisible"
        width="320px"
        :before-close="handleClose">
        <el-form ref="canteenUserUnplannedRefundForm" :model="canteenUserUnplannedRefundData" :rules="rules" label-width="100px">
          <el-form-item label="退款金额" :required="true" prop="canteenUserUnplannedRefundAmount">
            <el-input-number :min="0" :max="100000" :precision="2" v-model="canteenUserUnplannedRefundData.canteenUserUnplannedRefundAmount" style="width: 160px"></el-input-number> 元
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="canteenUserUnplannedRefund">退款</el-button>
            <el-button @click="canteenUserUnplannedRefundDialogVisible = false">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </el-container>
  </el-container>
</template>

<script>
import Top from './Top.vue'
import Menu from './Menu.vue'
export default ({
  components: {
    Menu,
    Top
  },
  data () {
    return {
      userInfo: {},
      schoolList: [],
      tableData: [],
      allAvailableCanteenAccountlList: [],
      loading: false,
      currentPage: 1,
      pageSize: 15,
      pageSizes: [15, 50, 100, 150, 200, 300, 500, 1000, 2000],
      total: 0,
      searchForm: {
        schoolId: null
      },
      canteenUserAccountRechargeData: {
        canteenUserAccountRechargeAmount: 0
      },
      canteenUserAccountRechargeDialogVisible: false,
      canteenUserAccountDrawData: {
        canteenUserAccountDrawAmount: 0
      },
      canteenUserAccountDrawDialogVisible: false,
      rules: {
        canteenUserAccountRechargeAmount: [{ required: true, message: '请输入充值金额', trigger: 'blur' }],
        canteenUserAccountDrawAmount: [{ required: true, message: '请输入取值金额', trigger: 'blur' }]
      },
      canteenUserAccountBatchRechargeDialogVisible: false,
      canteenUserAccountBatchRechargeData: {
        availableCanteenAccountList: [],
        canteenUserAccountBatchRechargeAmount: 0
      },
      canteenUserUnplannedOrderDialogVisible: false,
      canteenUserUnplannedOrderData: {
        canteenUserUnplannedOrderAmount: 0
      },
      canteenUserUnplannedRefundDialogVisible: false,
      canteenUserUnplannedRefundData: {
        canteenUserUnplannedRefundAmount: 0
      },
      toggleSelectValue: false
    }
  },
  mounted () {
    if (this.Cookie.get('userInfo') !== undefined && this.Cookie.get('userInfo') !== '') {
      this.userInfo = JSON.parse(this.Cookie.get('userInfo'))
      // this.getCanteenAccountlList()
      this.getSchoolList()
    }
  },
  methods: {
    goto (url) {
      if (url === this.$route.path) return
      this.$router.push(url)
    },
    handleClose (done) {
      done()
    },
    handleSizeChange (pageSize) {
      this.pageSize = pageSize
      this.getCanteenAccountlList()
    },
    openCanteenUserAccountRechargeDialog (userAccountData) {
      this.canteenUserAccountRechargeData.schoolId = userAccountData.schoolId
      this.canteenUserAccountRechargeData.userId = userAccountData.userId
      this.canteenUserAccountRechargeData.canteenUserAccountRechargeAmount = 0
      this.canteenUserAccountRechargeDialogVisible = true
    },
    openCanteenUserAccountDrawDialog (userAccountData) {
      this.canteenUserAccountDrawData.schoolId = userAccountData.schoolId
      this.canteenUserAccountDrawData.userId = userAccountData.userId
      this.canteenUserAccountDrawData.canteenUserAccountDrawAmount = 0
      this.canteenUserAccountDrawDialogVisible = true
    },
    openCanteenUserAccountBatchRechargeDialog () {
      this.canteenUserAccountBatchRechargeData.schoolId = this.searchForm.schoolId
      this.canteenUserAccountBatchRechargeData.canteenUserAccountBatchRechargeAmount = 0
      this.canteenUserAccountBatchRechargeData.availableCanteenAccountList = []
      this.canteenUserAccountBatchRechargeDialogVisible = true
    },
    openCanteenUserUnplannedOrderDialog (userAccountData) {
      this.canteenUserUnplannedOrderData.schoolId = userAccountData.schoolId
      this.canteenUserUnplannedOrderData.userId = userAccountData.userId
      this.canteenUserUnplannedOrderData.canteenUserUnplannedOrderAmount = 0
      this.canteenUserUnplannedOrderDialogVisible = true
    },
    openCanteenUserUnplannedRefundDialog (userAccountData) {
      this.canteenUserUnplannedRefundData.schoolId = userAccountData.schoolId
      this.canteenUserUnplannedRefundData.userId = userAccountData.userId
      this.canteenUserUnplannedRefundData.canteenUserUnplannedOrderAmount = 0
      this.canteenUserUnplannedRefundDialogVisible = true
    },
    getCanteenAccountlList () {
      let _this = this
      _this.loading = true
      this.$axios.post(this.GLOBAL.host + '/canteenAccount/list',
        this.$qs.stringify({
          currentUserId: _this.userInfo.id,
          schoolId: _this.searchForm.schoolId,
          realName: _this.searchForm.realName,
          page: _this.currentPage,
          size: _this.pageSize
        })
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.total = res.data.data.total
            _this.tableData = res.data.data.list
            _this.getAllAvailableCanteenAccountlList()
          } else {
            this.$message.error(res.data.message)
          }
        }
        _this.loading = false
      })
    },
    getAllAvailableCanteenAccountlList () {
      let _this = this
      _this.loading = true
      this.$axios.post(this.GLOBAL.host + '/canteenAccount/list',
        this.$qs.stringify({
          currentUserId: _this.userInfo.id,
          schoolId: _this.searchForm.schoolId,
          status: '1'
        })
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.allAvailableCanteenAccountlList = res.data.data.list
          } else {
            this.$message.error(res.data.message)
          }
        }
        _this.loading = false
      })
    },
    getSchoolList () {
      let _this = this
      this.$axios.post(this.GLOBAL.host + '/school/list',
        this.$qs.stringify({
          currentUserId: _this.userInfo.id,
          filterCanteen: '1'
        })
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.schoolList = res.data.data.list
            if (_this.schoolList.length > 0) {
              _this.searchForm.schoolId = _this.schoolList[0].id
              _this.getCanteenAccountlList()
              // _this.getAllAvailableCanteenAccountlList()
            }
          } else {
            this.$message.error(res.data.message)
          }
        }
      })
    },
    yuanOfBalanceFormatter (row) {
      return this.fenToyuanFormat(row.balance)
    },
    yuanOfLockedBalanceShoppingFormatter (row) {
      return this.fenToyuanFormat(row.lockedBalanceShopping)
    },
    yuanOfLockedBalanceOrderFormatter (row) {
      return this.fenToyuanFormat(row.lockedBalanceOrder)
    },
    fenToyuanFormat (fen) {
      let yuan = ''
      if (fen !== 0) {
        yuan = fen / 100 + '元'
      }
      return yuan
    },
    canteenUserAccountRecharge () {
      let _this = this
      this.$refs['canteenUserAccountRechargeForm'].validate((valid) => {
        if (valid) {
          // console.log(_this.canteenUserAccountRechargeData)
          // _this.canteenUserAccountRechargeData.canteenUserAccountRechargeAmount = (_this.canteenUserAccountRechargeData.canteenUserAccountRechargeAmount * 100).toFixed(0)
          this.$axios.post(this.GLOBAL.host + '/canteenAccount/canteenUserAccountRecharge',
            // this.$qs.stringify(_this.canteenUserAccountRechargeData)
            this.$qs.stringify({
              schoolId: _this.canteenUserAccountRechargeData.schoolId,
              userId: _this.canteenUserAccountRechargeData.userId,
              canteenUserAccountRechargeAmount: (_this.canteenUserAccountRechargeData.canteenUserAccountRechargeAmount * 100).toFixed(0)
            })
          ).then(res => {
            if (res.data != null) {
              if (res.data.status === 200) {
                _this.canteenUserAccountRechargeDialogVisible = false
                this.$message({
                  message: '充值成功',
                  type: 'success'
                })
                _this.getCanteenAccountlList()
                this.$refs['canteenUserAccountRechargeForm'].resetFields()
              } else {
                this.$message.error(res.data.message)
              }
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    canteenUserAccountDraw () {
      let _this = this
      this.$refs['canteenUserAccountDrawForm'].validate((valid) => {
        if (valid) {
          // console.log(_this.canteenUserAccountDrawData)
          // _this.canteenUserAccountDrawData.canteenUserAccountDrawAmount = (_this.canteenUserAccountDrawData.canteenUserAccountDrawAmount * 100).toFixed(0)
          this.$axios.post(this.GLOBAL.host + '/canteenAccount/canteenUserAccountDraw',
            this.$qs.stringify({
              schoolId: _this.canteenUserAccountDrawData.schoolId,
              userId: _this.canteenUserAccountDrawData.userId,
              canteenUserAccountDrawAmount: (_this.canteenUserAccountDrawData.canteenUserAccountDrawAmount * 100).toFixed(0)
            })
          ).then(res => {
            if (res.data != null) {
              if (res.data.status === 200) {
                _this.canteenUserAccountDrawDialogVisible = false
                this.$message({
                  message: '取值成功',
                  type: 'success'
                })
                _this.getCanteenAccountlList()
                this.$refs['canteenUserAccountDrawForm'].resetFields()
              } else {
                this.$message.error(res.data.message)
              }
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    canteenUserAccountCancel (userAccountData) {
      let _this = this
      this.$confirm('此操作会将用户账户的可用额转至学校账户, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.GLOBAL.host + '/canteenAccount/canteenUserAccountCancel',
          this.$qs.stringify({
            schoolId: userAccountData.schoolId,
            userId: userAccountData.userId
          })
        ).then(res => {
          if (res.data != null) {
            if (res.data.status === 200) {
              this.$message({
                message: '撤销成功',
                type: 'success'
              })
              _this.getCanteenAccountlList()
            } else {
              this.$message.error(res.data.message)
            }
          }
        })
      })
    },
    canteenUserAccountBatchRecharge () {
      let _this = this
      this.$confirm('请确认要对这些用户批量充值吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.GLOBAL.host + '/canteenAccount/canteenUserAccountBatchRecharge', {
          schoolId: _this.canteenUserAccountBatchRechargeData.schoolId,
          userIdList: _this.canteenUserAccountBatchRechargeData.availableCanteenAccountList,
          canteenUserAccountBatchRechargeAmount: (_this.canteenUserAccountBatchRechargeData.canteenUserAccountBatchRechargeAmount * 100).toFixed(0)
        }).then(res => {
          if (res.data != null) {
            if (res.data.status === 200) {
              this.$message.success(res.data.message)
              _this.getCanteenAccountlList()
              this.canteenUserAccountBatchRechargeDialogVisible = false
            } else {
              this.$message.error(res.data.message)
            }
          }
        })
      })
    },
    canteenUserUnplannedOrder () {
      let _this = this
      this.$confirm('请确认要进行加餐吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.GLOBAL.host + '/canteenOrder/handleUnplannedOrderOnPc',
          this.$qs.stringify({
            schoolId: _this.canteenUserUnplannedOrderData.schoolId,
            userId: _this.canteenUserUnplannedOrderData.userId,
            amount: (_this.canteenUserUnplannedOrderData.canteenUserUnplannedOrderAmount * 100).toFixed(0)
          })
        ).then(res => {
          if (res.data != null) {
            if (res.data.status === 200) {
              this.$message.success(res.data.message)
              _this.getCanteenAccountlList()
              this.canteenUserUnplannedOrderDialogVisible = false
            } else {
              this.$message.error(res.data.message)
            }
          }
        })
      })
    },
    canteenUserUnplannedRefund () {
      let _this = this
      this.$confirm('请确认要进行退款吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.GLOBAL.host + '/canteenOrder/unplannedRefund',
          this.$qs.stringify({
            schoolId: _this.canteenUserUnplannedRefundData.schoolId,
            userId: _this.canteenUserUnplannedRefundData.userId,
            amount: (_this.canteenUserUnplannedRefundData.canteenUserUnplannedRefundAmount * 100).toFixed(0)
          })
        ).then(res => {
          if (res.data != null) {
            if (res.data.status === 200) {
              this.$message.success(res.data.message)
              _this.getCanteenAccountlList()
              this.canteenUserUnplannedRefundDialogVisible = false
            } else {
              this.$message.error(res.data.message)
            }
          }
        })
      })
    },
    toggleSelect () {
      this.canteenUserAccountBatchRechargeData.availableCanteenAccountList = []
      if (this.toggleSelectValue) {
        this.allAvailableCanteenAccountlList.forEach(canteenAccount => {
          this.canteenUserAccountBatchRechargeData.availableCanteenAccountList.push(canteenAccount.userId)
        })
      } else {
      }
    }
  },
  computed: {
    checkedAvailableCanteenAccountIdList () {
      return this.canteenUserAccountBatchRechargeData.availableCanteenAccountList
    }
  },
  watch: {
    checkedAvailableCanteenAccountIdList () {
      this.toggleSelectValue = this.canteenUserAccountBatchRechargeData.availableCanteenAccountList != null && this.canteenUserAccountBatchRechargeData.availableCanteenAccountList.length === this.allAvailableCanteenAccountlList.length
    }
  }
})
</script>



// WEBPACK FOOTER //
// src/components/CanteenAccount.vue